import * as actionTypes from './authenticationActionTypes';

const initialState = {
    loggedIn: false,   
    username: "", 
    userId:0   
}

export default function authentication(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.LOGIN):
            if (state.username !== action.username) {  
                return Object.assign({}, state, { 
                    loggedIn: true,                   
                    username: action.username,
                    userId:action.userId          
                });
            }
            return state;
        case (actionTypes.LOGOUT):
            if (state.loggedIn === true) {
                return Object.assign({}, state, { loggedIn: false, username: "",userId:0 });
            }
            return state;
        default:
            return state;
    }
}


